module.exports = __webpack_public_path__ + "img/11B03_6.5cb538b4.png";